import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Thumbs, EffectFade } from "swiper/modules";
import SidebarWidgets from '../Common/SidebarWidgets';
import { api } from '../../services/api';
import { useContentItem } from '../../hooks/useContent';
import { getImageUrl } from '../../utils/imageUrl';

function ActivitiesDetailsMain() {
    const { id } = useParams();
    const { item: activityPost, loading, error } = useContentItem(api.getActivity, id);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    if (loading) {
        return <div className="container py-5 text-center">Loading activity...</div>;
    }

    if (error || !activityPost) {
        return <div className="container py-5 text-center text-danger">{error || 'Activity not found!'}</div>;
    }

    const images = [getImageUrl(activityPost.bannerImg || activityPost.image, 'tour')].filter(Boolean);

    return (
        <section className="space">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        <div className="tour-page-single">
                            {images.length > 0 && (
                            <div className="slider-area tour-slider1">
                                <Swiper
                                    modules={[Navigation, Thumbs, EffectFade]}
                                    effect="fade"
                                    loop={images.length > 1}
                                    spaceBetween={10}
                                    navigation={{
                                        prevEl: ".slider-prev",
                                        nextEl: ".slider-next",
                                    }}
                                    thumbs={{ swiper: thumbsSwiper }}
                                    className="swiper th-slider mb-25"
                                >
                                    {images.map((img, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="tour-slider-img">
                                                <img src={img} alt={`Slide ${index + 1}`} />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>

                                {images.length > 1 && (
                                <Swiper
                                    modules={[Navigation, Thumbs]}
                                    loop={true}
                                    spaceBetween={25}
                                    slidesPerView={3}
                                    watchSlidesProgress
                                    onSwiper={setThumbsSwiper}
                                    className="swiper tour-thumb-slider"
                                >
                                    {images.map((img, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="tour-slider-img">
                                                <img src={img} alt={`Thumbnail ${index + 1}`} />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                )}

                                <button className="slider-arrow style3 slider-prev">
                                    <img src="/assets/img/icon/hero-arrow-left.svg" alt="Prev" />
                                </button>
                                <button className="slider-arrow style3 slider-next">
                                    <img src="/assets/img/icon/hero-arrow-right.svg" alt="Next" />
                                </button>
                            </div>
                            )}
                            <div className="page-content">
                                <div className="page-meta mb-45">
                                    <Link className="page-tag mr-5" to="/activities">
                                        Featured
                                    </Link>
                                    <span className="ratting">
                                        <i className="fa-sharp fa-solid fa-star" />
                                        <span>{activityPost.rating || 4.8}</span>
                                    </span>
                                </div>
                                <h2 className="box-title">{activityPost.title}</h2>
                                {activityPost.price && (
                                    <h4 className="tour-price mb-30">
                                        <span className="currency">{activityPost.price}</span>
                                    </h4>
                                )}
                                {activityPost.description ? (
                                    <div
                                        className="box-text mb-50 cms-rich-content"
                                        dangerouslySetInnerHTML={{ __html: activityPost.description }}
                                    />
                                ) : (
                                    <p className="box-text mb-50">Activity details will appear here once updated from CMS.</p>
                                )}
                                {(activityPost.duration || activityPost.location) && (
                                <div className="tour-snapshot">
                                    <h4 className="box-title">Activity Snapshot</h4>
                                    <div className="tour-snap-wrapp">
                                        {activityPost.duration && (
                                        <div className="tour-snap">
                                            <div className="icon">
                                                <i className="fa-light fa-clock" />
                                            </div>
                                            <div className="content">
                                                <span className="title">Duration:</span>
                                                <span>{activityPost.duration}</span>
                                            </div>
                                        </div>
                                        )}
                                        {activityPost.location && (
                                        <div className="tour-snap">
                                            <div className="icon">
                                                <img src="/assets/img/icon/ship.svg" alt="" />
                                            </div>
                                            <div className="content">
                                                <span className="title">Location</span>
                                                <span>{activityPost.location}</span>
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                </div>
                                )}
                            </div>
                            {activityPost.map_embed && (
                            <div className="location-map">
                                <h3 className="page-title mt-45 mb-30">Activity Location</h3>
                                <div className="contact-map">
                                    <iframe
                                        src={activityPost.map_embed}
                                        allowFullScreen=""
                                        loading="lazy"
                                        title="Activity location"
                                    />
                                    <div className="contact-icon">
                                        <img src="/assets/img/icon/location-dot3.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <SidebarWidgets categoryType="tour" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ActivitiesDetailsMain
